import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

const Container = styled.div`
  display: flex;
  grid-area: cta;
  gap: 1rem;

  padding-top: 2rem;
  margin-top: 2rem;
  margin-left: 1rem;

  border-top: 0.1rem solid ${pickColor('gray')};
`;

export { Container };
